import { render } from "./FooterApp.vue?vue&type=template&id=ae008ac8&scoped=true"
const script = {}

import "./FooterApp.vue?vue&type=style&index=0&id=ae008ac8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae008ac8"]])

export default __exports__